if (!customElements.get('event-edit')) {
  customElements.define('event-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const products = Array.from(this.querySelectorAll('[data-event-product]'));
      const panels = Array.from(this.querySelectorAll('[data-event-panel]'));
      const buttons = Array.from(this.querySelectorAll('[data-event-category]'));
      const status = this.querySelector('[data-event-status]');
      const counts = { tops: 0, bottoms: 0 };
      products.forEach(product => { counts[product.dataset.category] += 1; });
      let category = 'tops';
      const update = () => {
        buttons.forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.eventCategory === category));
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.eventPanel !== category;
          panel.querySelector('[data-event-empty]').hidden = counts[panel.dataset.eventPanel] > 0;
        });
        status.textContent = `${counts[category]} ${category} items.`;
        if (window.AOS) window.AOS.refreshHard();
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        category = button.dataset.eventCategory;
        update();
      }));
      this.addEventListener('change', event => {
        const input = event.target.closest('[data-event-size][data-variant-id]');
        if (!input) return;
        const product = input.closest('[data-event-product]');
        product.querySelectorAll('.grid-product__image-mask > a, .grid-product__link').forEach(link => {
          link.href = `${product.dataset.productUrl}?variant=${input.dataset.variantId}`;
        });
      });
      const selectLowestAvailableSize = product => {
        const input = product.querySelector('.event-edit__sizes input:not(:disabled)');
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      products.forEach(selectLowestAvailableSize);
      // The shared PLP swatches change the card in place. Keep its size stock in sync.
      this.addEventListener('click', event => {
        const swatch = event.target.closest('.js-update-product');
        if (!swatch) return;
        const product = swatch.closest('[data-event-product]');
        const json = swatch.querySelector('script[type="application/json"]');
        if (!product || !json) return;
        const data = JSON.parse(json.textContent);
        const variants = data.variants.edges.map(edge => edge.node);
        const values = new Map();
        variants.forEach(variant => {
          const option = variant.selectedOptions.find(option => /size/i.test(option.name));
          const size = option ? option.value : variant.title.replace('Default Title', 'One size');
          if (!values.has(size) || (!values.get(size).availableForSale && variant.availableForSale)) values.set(size, variant);
        });
        const fieldset = product.querySelector('.event-edit__sizes');
        const legend = document.createElement('legend');
        legend.className = 'visually-hidden';
        legend.textContent = `${data.title} sizes`;
        fieldset.replaceChildren(legend);
        Array.from(values).forEach(([size, variant], index) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'variant-input';
          const input = document.createElement('input');
          input.type = 'radio';
          input.id = `EventSize-${product.dataset.productId}-${index + 1}`;
          input.name = `event-size-${product.dataset.productId}`;
          input.value = size;
          input.disabled = !variant.availableForSale;
          if (variant.availableForSale) {
            input.dataset.eventSize = size;
            input.dataset.variantId = variant.id.split('/').pop();
          }
          const label = document.createElement('label');
          label.htmlFor = input.id;
          label.className = `variant__button-label${input.disabled ? ' disabled' : ''}`;
          label.textContent = size;
          if (input.disabled) label.setAttribute('aria-label', `${size}, sold out`);
          wrapper.append(input, label);
          fieldset.append(wrapper);
        });
        product.dataset.productUrl = `${window.Shopify.routes.root}products/${data.handle}`;
        product.querySelector('.event-edit__stock').setAttribute('aria-label', `${data.title} size availability`);
        selectLowestAvailableSize(product);
      });
      this.querySelector('[data-event-controls]').hidden = false;
      this.setAttribute('data-ready', '');
      update();
    }
  });
}
